import React, { useEffect, useState } from 'react'
import CardDepoimento from './cardDepoimento'

export default function CarouselMax({ children, isMobile, currentIndex }) {
  const cardsInfo = [
    {
      expanded: false,
      evaluetion: 5,
      autor: 'Cristiano Silveira',
      cargo:
        'Superintendente de Tecnologia e Soluções Digitais Unimed Porto Alegre',
      depoimento:
        'Temos tido uma excelente experiência com a Projectiva durante o projeto de transformação ágil. Desde o início, demonstraram profundo conhecimento técnico, pro atividade e compromisso com prazos. A equipe trabalhou de forma colaborativa, compreendendo nossas necessidades e adaptando soluções a cultura e ao planejamento estratégico da Unimed Porto Alegre. A comunicação clara e o suporte contínuo tem sido diferenciais importantes, diante do desafio de mudar a mentalidade de entregas da área e aumentar a satisfação dos usuários.',
      image: '../assets/depoimentos/cristiano.png',
    },

    {
      expanded: false,
      evaluetion: 5,
      autor: 'Odilon Devens',
      cargo: 'Coordenador de TI da Taurus Armas S.A',
      depoimento:
        'A Projectiva é uma parceira com quem mantemos uma relação próxima e prática. Eles compreendem bem nossas necessidades e colaboram ativamente na busca por soluções. É um time confiável, com quem podemos contar no dia a dia.',
      image: '../assets/depoimentos/odilon.jpeg',
    },

    {
      expanded: false,
      evaluetion: 5,
      autor: 'Angela Gonçalves',
      cargo: 'Presidente da ADVBSC',
      depoimento:
        'Tivemos uma experiência bastante positiva com a Projectiva no Planejamento Estratégico da Advb/SC, proporcionando um importante suporte para uma transformação ágil dentro da entidade. O trabalho continua com o assessoramento e a manutenção dos objetivos propostos. Nos sentimos hoje mais capacitados enquanto grupo, nas nossas entregas e recomendamos o trabalho do consultor Cristiano Galina e da equipe da Projectiva.',
      image: '../assets/depoimentos/angela.png',
    },

    {
      expanded: false,
      evaluetion: 5,
      autor: 'Luiz Gustavo Furlan',
      cargo:
        'Gestão de Migração de Dados e consultores paraas frentes Fiscal, PP e FI',
      depoimento:
        'A Projectiva mostrou-se um parceiro flexível e ágil conseguindo identificar e disponibilizar rapidamente profissionais com bom nível técnico e comprometidos para nos apoiar em importantes frentes do nosso projeto. ',
      image: '../assets/depoimentos/luiz.jpeg',
    },

    {
      expanded: false,
      evaluetion: 5,
      autor: 'Vania Pankievicz',
      cargo: 'Sócia fundadora da GoGenetic',
      depoimento:
        'A Projectiva nos ajudou a desenvolver uma solução inédita no mercado brasileiro, compreendendo as demandas e a linguagem complexa da área de genética dos solos.',
      image: '../assets/depoimentos/vania.jpeg',
    },

    {
      expanded: false,
      evaluetion: 5,
      autor: 'Carla Barcelos',
      cargo: 'Cofundadora e Diretora da SB Eventos',
      depoimento:
        'A consultoria da Projectiva chegou no caminho da SB+ Eventos num momento de grande virada. Após um ano de pandemia e doze anos de empresa, nos vimos diante da principal mudança no nosso modelo de negócio e para isso buscamos uma assessoria para nos dar suporte. Em apenas um encontro, de uma forma dinâmica, objetiva e muito clara, o Galina nos apresentou muitas possibilidades e ali decidimos fechar a parceria. Estamos felizes com o desenvolvimento do trabalho e já colhemos frutos das medidas tomadas.',
      image: '../assets/depoimentos/carla.jpeg',
    },
  ]

  const [index, setIndex] = useState(0)
  const [indexExpanded, setIndexExpanded] = useState([0, 3])
  const [cards, setcards] = useState([])

  function makeCard() {
    setcards([])
    const cards = []
    for (let i = 0; i < cardsInfo.length; i++) {
      let expand

      indexExpanded.includes(i) ? (expand = true) : (expand = false)
      const card = (
        <CardDepoimento
          key={i}
          key_2={i}
          expanded={expand}
          evaluetion={cardsInfo[i].evaluetion}
          autor={cardsInfo[i].autor}
          cargo={cardsInfo[i].cargo}
          depoimento={cardsInfo[i].depoimento}
          image={cardsInfo[i].image}
          funcExpanded={updateindexExpand}
          isMobile={isMobile}
          cardIndex={i}
          activeIndex={index}
        />
      )

      cards.push(card)
    }

    setcards(cards)
  }

  function updateindexExpand(num) {
    console.log('teste')

    const expanded = [...indexExpanded]
    let intervalo

    for (let i = 0; i < cardsInfo.length; i++) {
      if (i % 3 === 0) {
        intervalo = [i, i + 1, i + 2]

        if (intervalo.includes(num)) {
          console.log(intervalo)
          break
        }
      }
    }

    console.log(intervalo)

    let elemento
    for (let i = 0; i < intervalo.length; i++) {
      if (expanded.includes(intervalo[i])) {
        elemento = intervalo[i]
        break
      }
    }

    if (elemento !== undefined) {
      expanded.splice(expanded.indexOf(elemento), 1)
    }

    expanded.push(num)
    console.log(expanded)

    setIndexExpanded(expanded)
  }

  // Garantir que os cards sejam recriados quando o estado de expansão mudar
  useEffect(() => {
    makeCard()
  }, [indexExpanded])

  useEffect(() => {
    if (currentIndex !== undefined) {
      setIndex(currentIndex)
    }
  }, [currentIndex])

  const indicators = []
  for (let i = 0; i < Math.ceil(cards.length / 3); i++) {
    indicators.push(
      <div
        key={i}
        onClick={() => setIndex(i)}
        className={`h-[8px] rounded-full cursor-pointer transition-all duration-300 ${i === index ? 'w-[40px] bg-transparent border border-white' : 'w-[20px] bg-white'}`}
      />,
    )
  }

  return (
    <div>
      {!isMobile ? (
        <div className="flex flex-col w-full h-[500px]">
          <div className="flex flex-row w-full gap-5 m-auto justify-center overflow-x-auto self-start align-top">
            {cards.filter(e => {
              const min = index * 3
              const max = min + 2

              if (e.key >= min && e.key <= max) {
                return e
              }
              return null
            })}
          </div>

          <div className="flex justify-center mt-8">
            <div className="flex flex-row gap-3 items-center">{indicators}</div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col w-full h-[470px]">
          <div className="flex flex-row w-full gap-2 m-auto justify-start overflow-x-auto">
            {cards.map((card, i) => {
              return React.cloneElement(card, {
                key: i,
                cardIndex: i,
                activeIndex: currentIndex,
              })
            })}
          </div>
        </div>
      )}
    </div>
  )
}
